import styled from 'styled-components';
// @ts-ignore
import rtl from 'styled-components-rtl';
import { theme, toRem } from '@marriott/mi-ui-library-shop';

export const StyledTextAreaDiv = styled.div`
  ${rtl`
    &.m-text-area {
      position: relative;
      box-sizing: border-box;

      textarea {
        width: 100%;
        padding: ${toRem(12)} 0 ${toRem(12)} ${toRem(16)};

        [dir="rtl"] & {
          padding: ${toRem(12)} ${toRem(16)} ${toRem(12)} 0;
        }

        border-width: 0.0625rem;
        border-style: solid;
        background-color: transparent;

        &:focus {
          border-color: var(--t-brand-fg-color);
          box-shadow: 0 0 0 0.03125rem inset;
        }
      }

      label {
        position: absolute;
        top: -0.47rem;
        left: ${toRem(11)};
        font-size: ${toRem(14)};
        text-transform: capitalize;
        background: ${theme.color['base-20']};
        padding: 0 0.375rem;
        font-weight: 500;
        letter-spacing: 0;
        color: ${theme.color['dark-gray-13']};
        margin-bottom: 0;

        [dir="rtl"] & {
          left: unset;
          right: ${toRem(11)};
        }
      }

      &.is-error textarea {
        border-color: var(--t-form-error-color) !important;
    }
      &.is-error {
        .error-text {
          color: var(--t-form-error-color);
      }
`}
`;
